module.exports = __webpack_public_path__ + "static/media/living-room.862c9a63.svg";